import {AsyncPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, viewChild} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {combineLatest, map, Observable} from 'rxjs';
import {SeFeModalModule} from 'se-fe-modal';
import {
  CatalogFormModalComponent,
  CatalogFormValue,
} from '../../../common/components/catalog-form-modal/catalog-form-modal.component';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {selectSelectedOrganizationId} from '../../../state/router/router.selectors';
import {CatalogActions} from '../store/catalog.actions';
import {selectCatalogError, selectCreateCatalogRequestState} from '../store/catalog.selectors';

@Component({
  selector: 'app-create-catalog',
  templateUrl: './create-catalog-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-create-catalog'},
  imports: [AsyncPipe, CatalogFormModalComponent, SeFeModalModule],
})
export class CreateCatalogModalComponent {
  readonly catalogFormModal = viewChild.required<CatalogFormModalComponent>('catalogFormModal');

  error$: Observable<ProductManagementErrorInterface | undefined>;
  creating$: Observable<boolean>;

  constructor(
    private store: Store,
    private router: Router
  ) {
    this.error$ = this.store.select(selectCatalogError);
    this.creating$ = this.store.select(selectCreateCatalogRequestState).pipe(map(({status}) => status === 'loading'));

    combineLatest([this.store.select(selectCreateCatalogRequestState), this.store.select(selectSelectedOrganizationId)])
      .pipe(takeUntilDestroyed())
      .subscribe(([{status, catalogId}, organizationId]) => {
        if (status !== 'success') {
          return;
        }

        setTimeout(() => {
          if (organizationId && catalogId !== undefined) {
            this.catalogFormModal().close();
            this.router.navigate(['/org', organizationId, 'commerce', 'catalogs', catalogId]);
          }
          this.store.dispatch(CatalogActions.resetCreateCatalogStatus());
        }, 0);
      });
  }

  createCatalog(catalog: CatalogFormValue): void {
    this.store.dispatch(
      CatalogActions.createCatalog({
        catalog,
      })
    );
  }

  open(trigger: HTMLElement): void {
    this.catalogFormModal().open(trigger);
  }
}
